module.exports = __webpack_public_path__ + "img/project.98fb2190.png";